import {
  fetchSlideClassification,
  fetchSpecimenClassification,
} from "shared/actions/aiActions";
import { useHasLoaded, useIsLoading } from "shared/hooks/requestStatusHooks";
import { SlideDetailState } from "shared/reducers/slideDetailReducer";

import { slideClassification } from "components/viewer/dialogs/utils";

export const useHasAILoaded = (slideDetailObject: SlideDetailState) => {
  const latestIndividualClassification = slideClassification(slideDetailObject);
  const specimenClassificationLoaded = useHasLoaded(
    fetchSpecimenClassification,
    {
      parentLookupCaseId: slideDetailObject.case_id || -1,
      id: slideDetailObject.specimen?.id || -1,
    }
  );
  const slideClassificationLoaded = useHasLoaded(fetchSlideClassification, {
    id: latestIndividualClassification?.id || -1,
    slide_id: slideDetailObject.id || -1,
  });

  return slideDetailObject?.specimen?.id
    ? specimenClassificationLoaded
    : slideClassificationLoaded;
};

export const useIsAILoading = (slideDetailObject: SlideDetailState) => {
  const latestIndividualClassification = slideClassification(slideDetailObject);
  const specimenClassificationLoading = useIsLoading(
    fetchSpecimenClassification,
    {
      parentLookupCaseId: slideDetailObject.case_id || -1,
      id: slideDetailObject.specimen?.id || -1,
    }
  );
  const slideClassificationLoading = useIsLoading(fetchSlideClassification, {
    id: latestIndividualClassification?.id || -1,
    slide_id: slideDetailObject.id || -1,
  });

  return slideDetailObject?.specimen?.id
    ? specimenClassificationLoading
    : slideClassificationLoading;
};
